import React, { useEffect, useRef } from "react";
import Hls from "hls.js";

type Props = {
   src: string;
   width?: string | number;
   height?: string | number;
   customStyles?: React.CSSProperties;
   controls?: boolean;
};

const HlsPlayer: React.FC<Props> = ({
   src,
   width = "100%",
   height = "100%",
   customStyles,
   controls
}) => {
   const videoRef = useRef<HTMLVideoElement>(null);

   useEffect(() => {
      if (!videoRef.current) return;

      if (Hls.isSupported()) {
         const hls = new Hls();
         hls.loadSource(src);
         hls.attachMedia(videoRef.current);
         hls.on(Hls.Events.ERROR, (data) => {
            console.error("HLS error:", data);
         });

         return () => {
            hls.destroy();
         };
      } else if (videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
         videoRef.current.src = src;
      }
   }, [src]);

   return (
      <video ref={videoRef} controls={controls} width={width} height={height} style={customStyles}>
         Twoja przeglądarka nie obsługuje odtwarzania HLS.
      </video>
   );
};

export default HlsPlayer;
